import { createStore } from 'vuex'
import createPersistedState from 'vuex-persistedstate'

export const store = createStore({
    plugins: [createPersistedState()],
    state: {
        rechargementId: '',
        civilite: '',
        nom: '',
        prenom: '',
        dateNaissance: ''
    },
    mutations: {
        change(state, { rechargementId, civilite, nom, prenom, dateNaissance }) {
            state.rechargementId = rechargementId
            state.civilite = civilite === 'Monsieur' ? 'M' : civilite === 'Madame' ? 'F' : ''
            state.nom = nom
            state.prenom = prenom
            state.dateNaissance = dateNaissance
        }
    },
    getters: {
        rechargementId: state => state.rechargementId,
        civilite: state => state.civilite,
        nom: state => state.nom,
        prenom: state => state.prenom,
        dateNaissance: state => state.dateNaissance
    }
})